import { Form, OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import InputMask from "react-input-mask";

import { VALID_EMAIL_STATUSES, INVALID_EMAIL_STATUSES, VALIDATION_MESSAGE } from "../../services/xVerifyEmailService";

export default function Communication({ state, onChange, onBlur, onKeyDown }) {
  const isEmailValid = state.verificationResult?.status && !state.verifying ? VALID_EMAIL_STATUSES.includes(state.verificationResult.status) : undefined;
  const isEmailInvalid = state.verificationResult?.status && !state.verifying ? INVALID_EMAIL_STATUSES.includes(state.verificationResult.status) : undefined;
  const invalidEmailMessage = VALIDATION_MESSAGE[state.verificationResult?.reason] || "You must provide a valid email address";

  return (
    <div>
      <h5>Communication</h5>
      <Form.Group controlId="customerPhone">
        <Form.Label>Phone Number</Form.Label>
        <InputMask mask="(999) 999-9999" maskChar={null} value={state ? state.customerPhone : ""} onChange={onChange}>
          {() => (
            <Form.Control
              required
              data-hj-allow
              type="phone"
              placeholder="(123) 456-7890"
              pattern=".{14,}"
              maxLength="14"
            />
          )}
        </InputMask>
        <Form.Control.Feedback type="invalid">You must provide a valid phone number</Form.Control.Feedback>
      </Form.Group>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Recipient E-mail</strong>
            <br />
            <strong>IMPORTANT:</strong> This is the e-mail where we will send the EIN Number, once processed. Make sure
            it is an e-mail that is checked frequently, and can receive incoming messages.
          </Tooltip>
        }
      >
        <Form.Group controlId="customerEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            required
            data-hj-allow
            type="email"
            placeholder="Enter email"
            pattern="^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
            defaultValue={state ? state.customerEmail : ""}
            isValid={isEmailValid}
            isInvalid={isEmailInvalid}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
          />
          {state.verifying && (
            <Form.Control.Feedback type="processing">
              Verification...
            </Form.Control.Feedback>
          )}
          <Form.Control.Feedback type="invalid">
            {invalidEmailMessage}
          </Form.Control.Feedback>
          {state.verifying && (
            <Spinner
              animation="border"
              variant="secondary"
              className="form-control-loader"
            />
          )}
        </Form.Group>
      </OverlayTrigger>
    </div>
  );
}
